<section class="testimonial-section" id="testimonial" style="padding:40px 0; overflow:hidden;">

  <h2 class="testimonial-title"
      style="text-align:center; font-size:32px; font-weight:700; margin-bottom:10px;">
    Testimonials
  </h2>

  <p class="testimonial-sub"
     style="text-align:center; font-size:18px; color:#555; margin-bottom:30px;">
    What our clients say about their experience
  </p>

  <div class="container" style="max-width:1200px; margin:auto;">
    <div class="row" style="margin:0;">
      <div class="col-12" style="padding:0;">
        <div class="swiper testimonial-swiper"
             data-slider-options='{
               "slidesPerView": 1.2,
               "spaceBetween": 20,
               "loop": true,
               "speed": 1200,
               "autoplay": { "delay": 2000, "disableOnInteraction": false },
               "breakpoints": {
                 "768": { "slidesPerView": 2.2 },
                 "1200": { "slidesPerView": 3 }
               }
             }'
             style="padding-bottom:10px;">

          <div class="swiper-wrapper">

            <!-- TESTIMONIAL ITEM -->
            <div class="swiper-slide" *ngFor="let review of testimonials"
                 style="height:auto; display:flex;">

              <div style="
                background:#fff;
                border-radius:20px;
                border:1px solid #eee;
                box-shadow:0 4px 20px rgba(0,0,0,0.05);
                padding:25px;
                transition:0.3s;
                display:flex;
                flex-direction:column;
                justify-content:space-between; /* ★ Keeps top text & bottom info separated */
                height:100%;
              "
              onmouseover="this.style.transform='translateY(-5px)'"
              onmouseout="this.style.transform='translateY(0)'">

                <!-- REVIEW TEXT -->
                <p style="
                  font-size:16px;
                  color:#444;
                  line-height:1.6;
                  margin-bottom:20px;
                ">
                  “{{ review.text }}”
                </p>

                <!-- BOTTOM SECTION (always stays at bottom) -->
                <div style="display:flex; align-items:center; margin-top:auto;">  
                  <img [src]="review.image"
                       style="
                         width:60px;
                         height:60px;
                         border-radius:50%;
                         object-fit:cover;
                       ">

                  <div style="margin-left:15px;">
                    <h6 style="
                      margin:0;
                      font-size:18px;
                      font-weight:600;
                      color:#000;
                    ">
                      {{ review.name }}
                    </h6>

                    <small style="color:#777; font-size:14px;">
                      {{ review.role }}
                    </small>
                  </div>
                </div>

              </div>
            </div>
            <!-- END ITEM -->
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
